import React from "react";
import { Handle, Position } from "reactflow";
import { BarsOutlined } from "@ant-design/icons";

import { useFlowNodes } from "../../../context";
import { ButtonDelete } from "../../ButtonDelete";
import ConditionalResponses from "components/Accordion/AccordionIntents/outputs/conditional_responses";
import { handleDeleteConditionalResponsesNode } from "../../utils/removeDataNode";

import "./ConditionalResponsesIntentNode.scss";

export const ConditionalResponsesIntentNode = ({ id }) => {
  const { t, setNodes, setEdges, ...res } = useFlowNodes();

  return (
    <>
      <div className="reponse-contentional-container">
        <div className="reponse-conditional">
          <Handle type="target" position={Position.Left} />
          <Handle type="source" id={id} position={Position.Right} />

          <div className="section-header">
            <div className="reponse-conditional-title">
              <div className="reponse-conditional-icon">
                <BarsOutlined />
              </div>
              <span className="reponse-conditional-name">
                {t(
                  "intents.config.accordion.responses.conditional_responses.title"
                )}
              </span>
            </div>
            <div className="reponse-conditional-actions">
              <ButtonDelete
                setNodes={setNodes}
                setEdges={setEdges}
                nodeId={id}
                handleDelete={() =>
                  handleDeleteConditionalResponsesNode(res.updateIntent)
                }
              />
            </div>
          </div>
          <div className="accordion__content">
            <ConditionalResponses
              {...{ isFlow: "true", ...res, type: "responses" }}
            />
          </div>
        </div>
      </div>
    </>
  );
};
